export default __webpack_public_path__ + "static/media/l3.84345ce3.jpg";